import type { Element } from 'html-react-parser';
import { camelCase, kebabCase, reduce, toPairs } from 'lodash/fp';

const tag = 'rich-text-mount-point';

export function createMountPoint(type: string, data: Record<string, string>, children = '') {
    const dataString = reduce((mem, [k, v]) => mem + ` data-${kebabCase(k)}="${v}"`, '', toPairs(data));
    return `<${tag} class="${type}" ${dataString} >${children}</${tag}>`;
}

export function replaceMountPoint(
    el: Element,
    type: string,
    callback: (dataset: Record<string, string>) => React.ReactElement
) {
    if (el.name === tag && el.attribs.class === type) {
        const dataset = Object.entries(el.attribs)
            .filter(([key]) => key.startsWith('data-'))
            .reduce<Record<string, string>>((acc, [key, val]) => {
                acc[camelCase(key.replace('data-', ''))] = val;
                return acc;
            }, {});
        return callback(dataset);
    }
}
